function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 670;


//////////////////
// WEBPACK FOOTER
// ./src/reducers \.js$
// module id = 670
// module chunks = 0